import { Component, DebugElement, EventEmitter, Input, OnInit } from '@angular/core';
import { UpdateData } from '../../models/update-data';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: '<app-update-modal>',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.css']
})
export class UpdateModalComponent implements OnInit {
  public constructor(private logger: LoggerService,
    private configValue: CustomizeResponseService) {
    this.modalData = [];
  }

  @Input() content!: any;
  @Input() isUpdate!: boolean;

  public modalData: UpdateData[];

  ngOnInit() {
    if (this.isUpdate) {
      this.modalData = this.configValue.customizeUpdate(this.content);
    } else {
      this.modalData = this.configValue.customizeAdd(this.content);
    }
  }
}
